module.exports = __webpack_public_path__ + "static/media/YB5M04_2.857a3d88.jpg";